import IBoardData from "../database/IBoardData";
import IEdgeData from "../database/IEdgeData";

/**
 * Describes the ComboBox data. Can also contain Board or Edge data.
 * // TODO: This is bad design. The ComboBox should get a template which kind of data it should display.
 *          And not mix Board and Edge data right into the ComboBox data.
 */
interface IComboBoxData extends Partial<IBoardData>, Partial<IEdgeData> {
    ID: string;
    Name: string;
    Hidden: boolean;
    DisplayName: string;
    CaptionDisplayName: string;
}

export default IComboBoxData;
